export { useProfileProtectionExtendedBeta } from './useProfileProtectionExtendedBeta';
